
export class ReferenceModule{
    static instance = angular.module('app.reference', []);
}
